import { render } from "./SelfPacedDetailsView.vue?vue&type=template&id=e7201b78"
const script = {}

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__